// Vyom public showcase library — LOCAL assets only (no external CDN dependency).
// Source-of-truth master library: /app/vyom-homepage-assets/ (with per-theme metadata.json).
// Serving copy: /app/frontend/public/vyom/ (poster.webp + 640w thumbnail.webp per item).
// These are Vyom-GENERATED cinematic STILLS (Gemini image), labelled "Vyom Production
// Concept". Each item exposes a null `video` slot — drop a genuine Vyom-generated MP4
// (or commercial-licensed demo MP4) in later WITHOUT changing the homepage.
const P = process.env.PUBLIC_URL || "";
const V = `${P}/vyom`;

export const HERO = {
  poster: `${V}/hero/hero-poster.webp`,
  posterMobile: `${V}/hero/hero-poster-mobile.webp`,
  video: null, // drop a genuine Vyom MP4 here (see /app/vyom-homepage-assets/hero/metadata.json)
};

export const OG_IMAGE = `${V}/hero/og-image.webp`;

export const SECTION_ART = {
  camera: `${V}/section-art/camera.webp`,
  vfx: `${V}/section-art/vfx.webp`,
  character: `${V}/section-art/character.webp`,
  production: `${V}/section-art/production.webp`,
  future: `${V}/section-art/future.webp`,
};

export const SHOWREEL_POSTER = `${V}/showreel/poster.webp`;

export const CATEGORIES = ["ALL", "CINEMA", "CAMERA", "VFX", "CHARACTERS", "WORLDS", "STORY", "COMMERCIAL", "DOCUMENTARY"];

const mk = (id, slug, title, category, tags, description) => {
  const dir = `${V}/showcase/${String(id).padStart(2, "0")}-${slug}`;
  return {
    id, slug, title, category, tags, description,
    poster: `${dir}/poster.webp`,
    thumbnail: `${dir}/thumbnail.webp`,
    video: null,               // replaceable slot
    glance: `${dir}/glance.mp4`, // 2-3 second motion clip rendered from the still
    duration: null,            // known once real footage is attached
    aspect: "16:9",
    width: 1264, height: 848,  // actual generated still dimensions (verified)
    collection: "core-20",
    created_with: "Vyom Production — cinematic still",
    source: "Vyom-generated (Gemini image)",
    watermark: false,
    showcase: true,
  };
};

// 20 cinematic concepts. The showcase carries no animation track.
export const SHOWCASE = [
  mk(1, "bollywood-rain", "Monsoon Reflections", "CINEMA", ["Emotion", "Camera"], "A rain-soaked Mumbai romance rendered in 35mm anamorphic character."),
  mk(2, "bollywood-dance", "Rooftop Spectacle", "CINEMA", ["Performance", "Scale"], "Large-scale Bollywood choreography on a palace terrace at sunset."),
  mk(3, "mumbai-chase", "Night Pursuit", "CAMERA", ["Action", "Tracking"], "A high-energy motorcycle chase through neon Mumbai rain."),
  mk(4, "desert-action", "Duststorm Run", "CAMERA", ["Action", "Golden hour"], "An armored expedition outruns a wall of desert dust."),
  mk(5, "enchanted-forest", "The Awakening Grove", "VFX", ["Fantasy", "Volumetric"], "A lantern-lit explorer reveals a hidden temple in a living forest."),
  mk(6, "scifi-city", "Vertical Metropolis", "WORLDS", ["Sci-Fi", "Worldbuilding"], "A rain-soaked megacity reveal across multiple traffic levels."),
  mk(7, "creature", "Ridge at Dawn", "CHARACTERS", ["Creature", "VFX"], "A photoreal fantasy creature with fur and breath simulation."),
  mk(8, "indian-epic", "The Standing Hero", "CHARACTERS", ["Epic", "Fantasy"], "A monumental mythology-inspired battlefield at sunrise."),
  mk(9, "underwater", "The Submerged City", "WORLDS", ["Adventure", "Environment"], "A diver descends toward vast ancient ruins in blue light."),
  mk(10, "historical-train", "Platform 1947", "STORY", ["Historical", "India"], "A period railway station brought to life in warm morning mist."),
  mk(11, "luxury-watch", "Mechanism", "COMMERCIAL", ["Product", "Macro"], "A macro luxury-watch commercial with controlled studio light."),
  mk(12, "wildlife", "Savannah Crossing", "DOCUMENTARY", ["Nature", "Long-lens"], "An observational herd crossing at golden sunrise."),
  mk(13, "warrior", "Mist & Steel", "CHARACTERS", ["Historical", "Action"], "A lone armored warrior in a fog-bound dawn forest."),
  mk(14, "space", "Ringrise", "WORLDS", ["Sci-Fi", "Epic"], "An astronaut beneath a colossal ringed planet at the horizon."),
  mk(15, "stop-motion", "Harbour Town", "VFX", ["Miniature", "Practical"], "A handcrafted miniature coastal village at sunrise."),
  mk(16, "horror", "The Long Corridor", "CAMERA", ["Horror", "Camera"], "A restrained psychological horror corridor track."),
  mk(17, "ocean-epic", "Against the Storm", "VFX", ["Epic", "Simulation"], "A tall ship battles a lightning-lit ocean storm."),
  mk(18, "indian-drama", "The Photograph", "STORY", ["Emotion", "India"], "An intimate, understated performance in soft dawn light."),
  mk(19, "vfx-city-event", "The Surge", "VFX", ["Action", "Destruction"], "A believable large-scale energy event between skyscrapers."),
  mk(20, "vyom-signature", "The Transformation", "CINEMA", ["Signature", "Multi-shot"], "Vyom's signature sequence — a monsoon street becomes a future city."),
];
